import apiUrl from '../../../../constants'
import axios from 'axios'
import CryptoJS from 'crypto-js';
import { Validator } from 'vee-validate'
import VueElementLoading from 'vue-element-loading';
import Paginate from "vuejs-paginate";
import JsZip from 'jszip'
import JSZipUtils from 'jszip-utils'
import { saveAs } from 'file-saver';
import PageTracker from '../../../../common/PageTrackerHelper'

export default {
  name: 'ChangeShipmentDetails',
  components: {
      VueElementLoading,
      Paginate,
      JsZip
  },
  mixins:[PageTracker],
  data: function() {
      return {
       Loading: false,
       localuserid:'',
       localusermailid:'',
       rolename:'',
       ShippingID:'',
       shipmentData:[],
       isLoading:false,
       ReturnMessage:'',
       ActiveTabIndex: 0,
       currentTab:'tab2',
       userDataKey : '',
      }
  },
  created: function() {},
  async mounted(){
    this.userDataKey = window.localStorage.getItem('userUniqueKey');
    let validateUser = await this.validateJwtToken();
    var userdetailEncrypt = window.localStorage.getItem('lmaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), this.userDataKey);
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.localuserid = userdetail.userid;
    this.localusermailid = userdetail.email;
    this.rolename = userdetail.userrole[0]['rolename'];
    this.hubname = userdetail.hubdetails[0];
    this.OutSourcingMasterId = userdetail.outsourcingid;

    // let TrackerInfo = {
    //     projectname:"Last Mile",
    //     type:"Web",
    //     userid:this.localuserid,
    //     username:this.localusermailid,
    //     meta: {
    //         "event":""
    //     }
    // }
    // let result  = this.PageTracker(TrackerInfo);
    //console.log('Mixin is working for :',result);
  },
  updated() {
    if(this.ActiveTabIndex == 0){
      $('.shipmentListtab ul li a:first').addClass('active')
    }
  },
  methods : {
    // changeDateFormat(inputString){
    //   let current_datetime = new Date(inputString)
    //   let formatted_date = current_datetime.getDate() + "-" + (current_datetime.getMonth() + 1) + "-" + current_datetime.getFullYear();
    //   return formatted_date;
    // },

    insertEBNByPassShipment(){
     this.$validator.validateAll().then(result => {

       if(this.ShippingID){
           this.isLoading = true
         let serchData = {
            "ShippingID":(this.ShippingID).trim(),
            "CreatedBy":this.localusermailid
          }
          axios({
              method: 'POST',
              'url': apiUrl.api_url + 'expose/Insert/EBNByPassShipment',
              'data': serchData
          })
          .then(async result => {
            if (result.data.code == 200) {
              this.$alertify.success(result.data.message);
            } else {
              this.$alertify.error(result.data.message);
            }
               this.isLoading = false
          })
       }
     })
    },
    reset(){
    this.ShippingID =''
    }

  }
}

Validator.extend('verify_shipments', {
  getMessage: field => "Invalid ShippingId. Please Enter valid shippingID",
  validate: value => {
      var ShippingID = $("#ShippingID").val();
      let flag=0;
      if(isNaN(ShippingID) || (ShippingID.length<3)){
        flag=1;
      }
      if(flag==1){
        return false;
      }else{
        return true;
      }
  }
});



// WEBPACK FOOTER //
// ./src/views/components/ManageShipment/ManageShipment/ManageShipment.component.js